const routes = [
    {
        name: 'listarRelatoriosNotasFiscais',
        path: '/emissor/relatorios_notas_fiscais',
        alias: '/emissor/relatorios_notas_fiscais/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'formularioRelatoriosNfe',
        path: '/emissor/relatorios_notas_fiscais/relatorio_nfe',
        component: () => import('../views/Nfe')
    },
    {
        name: 'formularioRelatoriosNfce',
        path: '/emissor/relatorios_notas_fiscais/relatorio_nfce',
        component: () => import('../views/Nfce')
    },
    {
        name: 'formularioRelatoriosNfse',
        path: '/emissor/relatorios_notas_fiscais/relatorio_nfse',
        component: () => import('../views/Nfse')
    },
    {
        name: 'impressaoRelatorio',
        path: '/emissor/relatorios_notas_fiscais/:tipo/gerar',
        component: () => import('@/shared/components/ui/Relatorio')
    },
]

export default routes
